import { createContext, useContext } from 'react';

import invariant from 'tiny-invariant';

export const CurrentEmployeeContext = createContext<string | undefined>(undefined);

export function useCurrentEmployeeId() {
  const id = useContext(CurrentEmployeeContext);
  invariant(id, 'To use `useCurrentEmployeeId` you must wrap your component in a `CurrentEmployeeContext.Provider`');

  return id;
}
